<template>
  <div>
    <TopContent
      :gelentur="gelentur"
      @aranan="aranan"
      @secilenDurum="secilenDurum"
    />

    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :suppressRowClickSelection="true"
      >


      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import TopContent from "../components/uzum-components/finans-components/TopContent.vue";
import StokIslemiButon from "../components/uzum-components/finans-components/StokIslemiButon.vue";

import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";

export default {
  data() {
    return {
      localeText: null,
      columnDefs: null,
      rowData: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      gelentur: "Stok",
      arananVal: "",
      dir: false,
      secilenDurumVal: "",
    
    };
  },
  components: {
    AgGridVue,
    TopContent,
    StokIslemiButon
  },
  mounted() {
    this.$root.$on("stoklistele", () => {
      // your code goes here
      this.listeleme();
    });
  },
  beforeDestroy() {
    this.$root.$off("stoklistele");
  },
  methods: {
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    
    secilenDurum(value) {
      this.secilenDurumVal = value;
      this.listeleme();
    },
    
    aranan(value) {
      this.arananVal = value;
      this.listeleme();
    },
    listeleme() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;

      const args = {
        token: Store.state.tokenId,
        ISLEM: "LIST",
        ARANAN: vm.arananVal,
        STATUS: vm.secilenDurumVal,

        STOCKID: "",
        STOCKNO: "",
        BARKOD: "",
        STOCKNAME: "",
        GROUPCODE: "",
        BIRIMAGIRLIK: "",
        BIRIM: "",
        DESCRIPTION: "",
        INSERTUSERID: "",
        EDITUSERID: "",
      };
      soap.createClient(url, function (err, client) {
        client.UZM_STOCKLIST(args, function (err, result) {
          if (result.UZM_STOCKLISTResult == "-1") {
            Store.dispatch("logout");
          }
          try {
            vm.veriler = JSON.parse(result.UZM_STOCKLISTResult);
            vm.rowData = vm.veriler;

          } catch (error) {
            console.log(error);
          }
        });
      });
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 170,
        field: "",
        cellRendererFramework: "StokIslemiButon",
      },

      {
        headerName: "Stok Kodu",
        field: "STOCKNO",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Barkod",
        filter: "agTextColumnFilter",
        field: "BARKOD",
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Grup Kodu",
        field: "GROUPCODE",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Birim",
        field: "BIRIM",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Birim Ağırlık",
        field: "BIRIMAGIRLIK",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Giriş Mik.",
        field: "DISCOUNTSUM",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Çıkış Mik.",
        field: "VATSUM",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Kalan Mik.",
        field: "TOTAL",
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Resim",
        field: "TOTAL",
        filter: "agTextColumnFilter",
      },
    ];
  },
  created() {
    this.listeleme();
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
  },
};
</script>
<style lang="scss">
table.vgt-table {
  font-size: small;
}
.VGT-row:hover {
  background-color: rgb(219, 219, 250);
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
</style>